import { render } from "./CenterForm.vue?vue&type=template&id=0745a579&ts=true"
import script from "./CenterForm.vue?vue&type=script&lang=ts"
export * from "./CenterForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Center/CenterForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0745a579"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0745a579', __exports__)) {
    api.reload('0745a579', __exports__)
  }
  
  module.hot.accept("./CenterForm.vue?vue&type=template&id=0745a579&ts=true", () => {
    api.rerender('0745a579', render)
  })

}


export default __exports__